import { useEffect } from 'react'

const CSS_VAR = '--paypal-header-height'

/** Selectors to try (V2 #globalnav-header, V1 pp-header, mobile cw_navbar) */
const HEADER_SELECTORS = [
  '#globalnav-header',
  '.vx_globalNav-container',
  '[id*="globalnav"]',
  'header[class*="pp-header"]',
  '.cw_navbar_mobile'
]

const findHeader = (): HTMLElement | null => {
  for (const sel of HEADER_SELECTORS) {
    const el = document.querySelector<HTMLElement>(sel)
    if (el?.offsetHeight) {
      return el
    }
  }
  return null
}

/**
 * Measures header and sets --paypal-header-height CSS variable.
 * Use var(--paypal-header-height, 72px) in styles for programmatic header offset.
 */
export const useHeaderHeight = () => {
  useEffect(() => {
    let observer: ResizeObserver | null = null
    const retryDelays = [0, 100, 300, 600, 1000]
    const retryIds: ReturnType<typeof setTimeout>[] = []

    const observe = (header: HTMLElement) => {
      const setHeight = () => {
        const height = header.offsetHeight
        if (height > 0) {
          document.documentElement.style.setProperty(CSS_VAR, `${height}px`)
        }
      }

      setHeight()
      observer = new ResizeObserver(setHeight)
      observer.observe(header)
    }

    retryDelays.forEach(delay => {
      const id = setTimeout(() => {
        const header = findHeader()
        if (header && !observer) {
          observe(header)
        }
      }, delay)
      retryIds.push(id)
    })

    return () => {
      retryIds.forEach(clearTimeout)
      // eslint-disable-next-line no-unused-expressions
      observer?.disconnect()
      document.documentElement.style.removeProperty(CSS_VAR)
    }
  }, [])
}
